import React from "react";
import {withRouter} from "next/router";
import {Box, Text} from "grommet";
import NextAnchor from "./NextAnchor";
import { isActive } from "../utils/router";

const NavButton = ({ label, active, replace, ...rest }) => (
    <NextAnchor
        label={(
            <Box
                width={{ min: 'xsmall' }}
                pad={{ vertical: 'xxsmall', horizontal: 'xsmall' }}
                responsive={false}
                align="center"
                border={{ side: 'bottom', size: 'small', color: active ? 'brand' : 'border-strong' }}
            >
                <Text size="small">{label}</Text>
            </Box>
        )}
        margin={{ vertical: 'xxsmall', horizontal: 'xxsmall' }}
        size="small"
        plain
        hoverIndicator
        button
        replace={replace}
        {...rest}
    />
);

const SubMenu = ({ items, router, replace, ...rest}) => (
    <Box direction="row" responsive={false} flex={false} gap="xxsmall" margin={{ bottom: 'small' }} overflow={{ horizontal: 'auto' }} {...rest}>
        {items.map((item, index) => 
            <NavButton 
                key={item.label} 
                active={isActive(item.href, router.asPath, item?.regExp, item?.exclude)} 
                href={item.href} 
                replace={replace}
                label={item.label} />
        )}
    </Box>
);

export default withRouter(SubMenu);
